// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"78298aaa","281":"e55a497c","419":"5a20cba9","440":"63608dbb","470":"845c064f","608":"e690fe7c","726":"cc948fe6","790":"16d489d9","830":"3a2584a2","896":"5aeb7540","937":"e4359712","987":"639f302b"}[chunkId] + ".chunk.js";
};